import { appApi } from "@/api/app.api.ts";
import { ApiErrorException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/react-query";

export const appKeys = createQueryKeys("app", {
  config: {
    queryKey: ["config"],
    queryFn: async () => {
      const result = await appApi.getConfig();
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  },
  menuCounters: {
    queryKey: ["menuCounters"],
    queryFn: async () => {
      const result = await appApi.getMenuCounters();
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  },
});

export const useAppConfig = (enabled: boolean = true) => {
  return useQuery({
    ...appKeys.config,
    staleTime: 10 * 60 * 1000,
    enabled,
  });
};

export const useMenuCounters = (enabled: boolean = true) => {
  return useQuery({
    ...appKeys.menuCounters,
    staleTime: 60 * 1000,
    enabled,
  });
};
